import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Componets/Header";
import Table from "../../../Componets/Table";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import Loadercomponent from "../../../Componets/Loader";
import {  
  download_all_products_reports_csv,
  get_all_products_reports,
} from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";

const ProductReport = () => {
  let componentRef = useRef();
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState([]);
  const [total, setTotal] = useState(0);
  const [role, setRole] = useState("");
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
    totalCount: 0
  });

  const headers = {
    name: "Products",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: 0, label: "Name (A-Z)" },
          { value: 1, label: "Name (Z-A)" },
          { value: 2, label: "Stock (Low)" },
          { value: 3, label: "Stock (High)" },
        ],
      },
      {
        type: "filter",
        name: "unit",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Units",
        api: "get-all-product-units",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "category",
        placeholder: "Category",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        api: "get-all-product-categories",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "brand",
        placeholder: "Brands",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        api: "get-all-product-brands",
        value: null,
        options: null,
      },
    /*   {
        type: "filter",
        name: "type",
        placeholder: "Type",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: 0, label: "Non-Stockable" },
          { value: 1, label: "Stockable" },
        ],
      }, */
     /*  {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: "0", label: "Inactive" },
          { value: "1", label: "Active" },
        ],
      }, */
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Product",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total" },
        { value: 0, label: "Active" },
        { value: "0", label: "Inactive" },
      ],
    },
  };

  const tables = [
    { name: "Name", key: "Name" },
    { name: "Units", key: "Units" },
    { name: "Category", key: "Category" },
    { name: "Brands", key: "Brands" },
    { name: "Branch", key: "Branch" },
    { name: "Stock", key: "Stock" },
  ];

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      unit: headerdata?.unit,
      category: headerdata?.category,
      brand: headerdata?.brand,
      type: headerdata?.type,
      status: headerdata?.status,
      branch: headerdata?.branch,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        unit: tabledata?.unit,
        category: tabledata?.category,
        brand: tabledata?.brand,
        type: tabledata?.type,
        status: tabledata?.status,
        branch: tabledata?.branch,
        page: tabledata?.currentPage || 1,
        limit: 50,
      };

      const productsResponse = await get_all_products_reports(data);


      if (productsResponse?.status) {
        const tableData = productsResponse?.data?.data?.map((product, index) => {
          return {
            Name: product?.name || "-",
            Units: product?.unit?.name || "-",
            Category: product?.category?.name || "-",
            Brands: product?.brand?.name || "-",
            Branch: product?.branch?.name || "-",
            Stock: product?.total_inventory ? parseFloat(product.total_inventory).toFixed(3) : "0.000"
          };
        }) || [];

        setBody(tableData);
        setRole(productsResponse?.data?.role)
        setTotal(productsResponse?.data?.grand_total_inventory || 0);

        setPagination({
          currentPage: productsResponse?.data?.currentPage || 1,
          totalPages: productsResponse?.data?.totalPages || 0,
          totalCount: productsResponse?.data?.totalCount || 0
        });

        setLoader(false);
      } else {
        toast?.error(productsResponse?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!role) return;

    let updatedHeader = { ...headers };

    if (role !== "SUPERADMIN") {
      updatedHeader.components = updatedHeader.components.filter(
        (item) => item.name !== "branch"
      );
    }

    setHeader(updatedHeader);
  }, [role]);


  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value, index) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  const fetchAllProducts = async () => {
    try {
      const headerdata = {};
      header?.components?.map((value, index) => {
        headerdata[value.name] = value.value;
      });

      const data = {
        search: headerdata?.search,
        sort: headerdata?.sort,
        unit: headerdata?.unit,
        category: headerdata?.category,
        brand: headerdata?.brand,
        type: headerdata?.type,
        status: headerdata?.status,
        branch: headerdata?.branch,
        source: "Product_Report"
      };

      const response = await get_all_products_reports(data);
      return response?.status ? response?.data?.data : [];
    } catch (error) {
      toast.error("Failed to fetch products for download");
      return [];
    }
  };

  const downloadCSV = async () => {
    try {
      const allProducts = await fetchAllProducts();

      if (!allProducts || allProducts.length === 0) {
        toast.error("No data available to download");
        setLoader(false);
        return;
      }

      const headers = ["S.No", "Name", "Units", "Category", "Brands", "Branch", "Stock"];

      const csvContent = [
        headers.join(","),
        ...allProducts.map((product, index) => [
          index + 1,
          `"${product?.name || ""}"`,
          `"${product?.unit?.name || ""}"`,
          `"${product?.category?.name || ""}"`,
          `"${product?.brand?.name || ""}"`,
          `"${product?.branch?.name || ""}"`,
          product?.total_inventory ? parseFloat(product.total_inventory).toFixed(3) : "0.000"
        ].join(","))
      ].join("\n");

      const encoder = new TextEncoder();
      const encodedContent = encoder.encode('\uFEFF' + csvContent);

      const blob = new Blob([encodedContent], { type: 'text/csv;charset=utf-8' });

      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", `Products_Report_${new Date().toLocaleDateString().replace(/\//g, '_')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to generate CSV file");
    }
  };

  const downloadPDF = async () => {
    try {
      const allProducts = await fetchAllProducts();

      if (!allProducts || allProducts.length === 0) {
        toast.error("No data available to download");
        setLoader(false);
        return;
      }

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      registerCairoFont(doc);
      const pageWidth = doc.internal.pageSize.getWidth();

      doc.setFont("Cairo-Bold", "bold");

      doc.setFontSize(18);
      doc.text("Products Report", pageWidth / 2, 18, { align: "center" });

      const now = new Date();
      const formattedDate = now.toLocaleDateString("en-GB");
      const formattedTime = now.toLocaleTimeString();
      doc.setFontSize(10);
      doc.text(`Downloaded on: ${formattedDate} ${formattedTime}`, pageWidth / 2, 26, { align: "center" });

      const tableRows = allProducts.map((product, index) => [
        index + 1,
        product?.name || "-",
        product?.unit?.name || "-",
        product?.category?.name || "-",
        product?.brand?.name || "-",
        product?.branch?.name || "-",
        product?.total_inventory ? parseFloat(product.total_inventory).toFixed(3) : "0.000"
      ]);

      autoTable(doc, {
        startY: 32,
        head: [["S.No", "Name", "Units", "Category", "Brands", "Branch", "Stock"]],
        body: tableRows,
        styles: {
          font: "Cairo",
          textColor: [0, 0, 0],
          lineColor: [222, 222, 222],
          fillColor: false,
          lineWidth: 0.2
        },
        headStyles: {
          font: "Cairo",
          fontStyle: "bold",
          fillColor: false,
          lineColor: [222, 222, 222],
          lineWidth: 0.2
        },
        alternateRowStyles: {
          fillColor: false,
        }
      });

      doc.autoPrint();

      const pdfBlob = doc.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);

      window.open(pdfUrl);
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF file");
    }
  };

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <div className="text-right pb-4 flex gap-3 justify-end mt-4">
        <Button
          className="mr-2 !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
          type="primary"
          onClick={downloadCSV}
        >
          Download CSV
        </Button>

        <Button
          className="mr-2 !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
          type="primary"
          onClick={downloadPDF}
        >
          Download PDF
        </Button>

      </div>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
          componentRef={componentRef}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ProductReport;